import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface RatingStarProps {
  isSelected?: boolean;
  isHover?: boolean;
  style?: React.CSSProperties;
}

export default function AnalyticsIcon({ isSelected = false, isHover = false, style = {}, ...props }: RatingStarProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 19 20" style={{ width: `20px`, height: `20px`, ...style }}>
      <g>
        <path
          d="M4.9611 11.9H1.4361C1.34866 11.9 1.27777 11.9709 1.27777 12.0584V18.6167C1.27777 18.7041 1.34866 18.775 1.4361 18.775H4.9611C5.04855 18.775 5.11944 18.7041 5.11944 18.6167V12.0584C5.11944 11.9709 5.04855 11.9 4.9611 11.9Z"
          fill={isHover ? RoutalPalette.primary20 : isSelected ? RoutalPalette.primary40 : RoutalPalette.secondary40}
          stroke={isHover ? RoutalPalette.primary20 : isSelected ? RoutalPalette.primary40 : RoutalPalette.secondary40}
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M11.9777 0.833313H8.45271C8.36526 0.833313 8.29437 0.904201 8.29437 0.991646V18.625C8.29437 18.7124 8.36526 18.7833 8.45271 18.7833H11.9777C12.0652 18.7833 12.136 18.7124 12.136 18.625V0.991646C12.136 0.904201 12.0652 0.833313 11.9777 0.833313Z"
          fill={isHover ? RoutalPalette.primary20 : isSelected ? RoutalPalette.primary40 : RoutalPalette.secondary40}
          stroke={isHover ? RoutalPalette.primary20 : isSelected ? RoutalPalette.primary40 : RoutalPalette.secondary40}
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M18.9944 5.85004H15.4694C15.382 5.85004 15.3111 5.92092 15.3111 6.00837V18.625C15.3111 18.7125 15.382 18.7834 15.4694 18.7834H18.9944C19.0819 18.7834 19.1528 18.7125 19.1528 18.625V6.00837C19.1528 5.92092 19.0819 5.85004 18.9944 5.85004Z"
          fill={isHover ? RoutalPalette.primary20 : isSelected ? RoutalPalette.primary40 : RoutalPalette.secondary40}
          stroke={isHover ? RoutalPalette.primary20 : isSelected ? RoutalPalette.primary40 : RoutalPalette.secondary40}
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
    </SvgIcon>
  );
}
